{
  "test": "Hello",
  "test {{foo}} {{bar}}": "Hello",
  "settings_shops_page.invoicing_address.label": "E-invoicing address",
  "settings_shops_page.invoicing_address.invalid_format": "Invalid e-invoicing address format. Expected format: 0009:12345678901234"
}
